export function runningOnRobot() {
  return window.location.href.includes(':28800');
}

export function isLocalHost() {
  return window.location.href.includes('http://localhost:');
}